// extracted by mini-css-extract-plugin
export default {"container":"styles_container__uwZ2H","paragraph":"styles_paragraph__xLwmE"};